// src/user/UserDashboard.jsx

import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './UserDashboard.css';

export default function UserDashboard() {
  return (
    <div className="dashboard-container">
      <aside className="dashboard-sidebar">
        <h2 className="sidebar-logo"></h2>
        <nav className="sidebar-nav">
          <NavLink to="" end className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            Profile
          </NavLink>
          <NavLink to="security" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            Security
          </NavLink>
          <NavLink to="billing" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            Billing
          </NavLink>
            {/* <NavLink to="history" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            Chat History
          </NavLink>
          <NavLink to="assistant" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            AI Assistant
          </NavLink> */}
        </nav>
      </aside>

      <main className="dashboard-content">
        <Outlet />
      </main>
    </div>
  );
}